module.exports = __webpack_public_path__ + "media/music/punchy_bass_3-61e86f3b.mp3";